import type { StorageType } from "@/types";

export const DOMAIN = process.env.PUBLIC_APP_OKTA_DOMAIN;
export const AUTHORIZE_URL = `https://${DOMAIN}/oauth2/default/v1/token`;
export const CLIENT_ID = process.env.PUBLIC_APP_OKTA_CLIENT_ID;
export const ISSUER = `https://${DOMAIN}/oauth2/default`;

const oktaDefaultConfig = {
  clientId: `${CLIENT_ID}`,
  issuer: ISSUER,
  redirectUri: `${window.location.origin}/login/callback`,
  //scopes: ["openid"],
  // scopes: ["openid", "profile", "email", "offline_access"],
  tokenManager: {
    storage: "cookie",
  },
  storageManager: {
    token: {
      storageType: "cookie" as StorageType,
    },
  },
  cookies: {
    secure: window.location.protocol === "https:",
  },
};

const oktaTestConfig = {
  issuer: "https://foo",
  clientId: "foo",
  redirectUri: "https://foo",
};

const oktaConfig =
  process.env.NODE_ENV !== "test" ? oktaDefaultConfig : oktaTestConfig;

export default oktaConfig;
